module.exports = __webpack_public_path__ + "img/five2Green.3c3c6d6d.jpg";